import React from 'react';
import { Box, Checkbox, FormControlLabel, makeStyles, Popover } from '@material-ui/core';
import f from '../../../../../comm/fontStyles';
import { classNames, onKeyUpEnterOrSpace } from '../../../../../utils';
import { i18n } from '../../../../../language';
const styles = makeStyles((theme) => ({
  popover: {
    marginTop: '0.625rem',
    '& .MuiPaper-rounded': {
      borderRadius: '0.625rem !important',
    },
    '& .MuiPaper-root': {
      boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
    },
  },
  root: {
    maxHeight: '20rem',
    width: '10.625rem',
    '& > :hover': {
      background: '#f5faff',
    },
    '& .MuiFormControlLabel-label:hover': {
      color: '#538fff',
    },
  },
  checkBody: {
    padding: '0.1rem 1.25rem',
  },
  checkBox: {
    '& .MuiTypography-root': {
      ...f.NM_500_1rem,
      color: '#2e4469',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  isCheck: {
    '& .MuiFormControlLabel-label': {
      color: '#538fff',
    },
  },
}));

export default function SelectCheckBoxPop({
  id,
  anchorEl,
  itemList,
  closePop,
  value,
  onChange,
  isAllSelect,
  allSelectChange,
}) {
  const classes = styles();

  const onCheckChangeHandle = (curItem) => {
    return (event) => {
      if (!onChange && !value) return;
      if (event) {
        onChange([...value, curItem.value], curItem);
      } else {
        onChange(
          value.filter((item) => {
            return item !== curItem.value;
          }),
          curItem
        );
      }
    };
  };

  const checkBox = (item, index) => {
    const { value: v, text } = item;
    const check = Array.isArray(value) && value.includes(v);
    return (
      <div
        key={value + index}
        className={classes.checkBody}
        onClick={() => {
          onCheckChangeHandle(item)(!check);
        }}
        id={`Notification-option-${index}`}
        tabIndex={0}
        onKeyUp={(e) =>
          onKeyUpEnterOrSpace(e, () => {
            onCheckChangeHandle(item)(!check);
          })
        }
      >
        <FormControlLabel
          control={<Checkbox />}
          id="Notification-FormControlLabel-abh"
          label={text}
          name={text}
          className={check ? classNames(classes.checkBox, classes.isCheck) : classes.checkBox}
          checked={check}
        />
      </div>
    );
  };

  return (
    <Popover
      id={id}
      className={classes.popover}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={closePop}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Box display="flex" flexDirection="column" className={classes.root}>
        <FormControlLabel
          control={<Checkbox />}
          label={i18n.t('BEDSTATUS_SELECT_ALL')}
          className={isAllSelect ? classNames(classes.checkBox, classes.isCheck) : classes.checkBox}
          checked={isAllSelect}
          style={{ padding: '0.1rem 1.25rem' }}
          onChange={() => {
            allSelectChange(!isAllSelect);
          }}
          id="Notification-FormControlLabel-abi"
        />
        {Array.isArray(itemList) &&
          itemList.map((item, index) => {
            return checkBox(item, index);
          })}
      </Box>
    </Popover>
  );
}
